/*
 * @Description: 项目配置文件，这里不做环境相关配置
 * @Autor: Popper_Li
 */
export default {
  // token的名字
  tokenName: 'token'
}